import Vue from 'vue';
import store from './store/charibonStore.js';
import router from "./routes/charibonRouter.js";
import "./sass/charibon_common.scss"

import {Intersect} from 'vuetify/lib/directives'
import vuetify, {setUserPresetLightThemes} from './plugin/vuetify'
import axios from 'axios';
import vueConfig from './vue.config.js';
// Setup VeeValidate
import {setupVeeValidate} from './plugin/veeValidate.js'
import {VApp, VMain} from 'vuetify/lib'

const customLightThemeOptions = {
    background: '#fff6e2',
    primaryTextColor: '#1F3134',
    secondary: '#E60A9B',
    accent: '#58a0c1',
    accent2: '#F7F5EB',
    accent3: '#00475A',
    anchor: '#1a73e8',
}
setUserPresetLightThemes(customLightThemeOptions);

window.axios = axios;

window.VueConfig = vueConfig;

setupVeeValidate(Vue)

Vue.directive('intersect', Intersect)

/**
 * フィルター定義
 */
// 金額をカンマ区切りにする
Vue.filter('addCommaSeparator', function (value) {
    return value == null || isNaN(value) ? '' : value.toLocaleString();
});

// 判定識別子
Vue.prototype.$siteCode = VueConfig.siteCode.charibon;

// ヘッダー・フッター
import CharibonHeader from "./components/organisms/charibon/charibon-header.vue";
import CharibonFooter from "./components/organisms/charibon/charibon-footer.vue";


// baseタグのSPAのルート定義 charibon|chadev の場合、baseを /form/ とする
const url = location.href;
// ※条件要検討：urlにcharibonが含まれると本番とみなしてしまう
if (url.match(/www.charibon.jp|chadev|chastg|closedcharibon|chaprd/g)) {
    axios.defaults.baseURL = "/form"
}

/**
 * カスタムディレクティブ
 */
// v-showではdisplay:noneしかできないため、visibility: hiddenを使えるようにする
// v-visible=(条件)で使用する
Vue.directive('visible', function (el, binding) {
    el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});

new Vue({
    el: '#app_charibon',
    router,
    vuetify,
    store,
    components: {
        VApp,
        VMain,
        CharibonHeader,
        CharibonFooter
    },
});
